import React from 'react';

export function GushAndHelkaFormatter(gush, helka, ttHelka) {
  const text = (gush || helka || ttHelka)
    ? [gush, helka, ttHelka].filter(Boolean).join('/')
    : '';

  return (
    <div className="font-weight-bolder">
      {text}
    </div>
  );
}
